<template>
  <div>
    <transition name="fade">
      <CCard v-if="show" color="">
        <CCardHeader>
          Add Division
          <div class="card-header-actions">
            <CLink
              class="card-header-action btn-minimize"
              @click="isCollapsed = !isCollapsed"
            >
              <CIcon :name="`cil-chevron-${isCollapsed ? 'bottom' : 'top'}`" />
            </CLink>
            <CLink
              href="#"
              class="card-header-action btn-close"
              v-on:click="show = false"
            >
              <CIcon name="cil-x" />
            </CLink>
          </div>
        </CCardHeader>
        <CCollapse :show="isCollapsed" :duration="400">
          <CCardBody>
            <form>
             

              <div class="form-group row">
                <label
                  for="subjectFormControlSelect"
                  class="col-sm-4 col-form-label"
                  >School</label
                >
                <div class="col-sm-8">
                  <select class="form-control" v-model="form.school">
                    <option value disabled hidden>Select School</option>
                    <option
                        v-for="(y,i) in school_list"
                        v-bind:key="i"
                        :value="y.school_id"
                    >{{y.school_name}}</option>
                  </select>
                </div>
              </div>
              <!-- end form-group -->

              <div class="form-group row">
                <label
                  for="subjectFormControlSelect"
                  class="col-sm-4 col-form-label"
                  >Division</label
                >
                <div class="col-sm-8">
                  <input type ="text" name="school" class="form-control" placeholder="Division"  v-model="form.division">
                </div>
              </div>
            
              <div class="form-group row">
                <div class="col-sm-8 offset-sm-4">
                  <CButton color="primary" size="md" class="border-0" @click="onSubmit1">
                    Submit
                  </CButton>&nbsp;&nbsp;
                  
                  <button type="submit" class="btn btn-light">
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </CCardBody>
        </CCollapse>
      </CCard>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import apis from '@/apis';
import $ from "jquery";
import Swal from 'sweetalert2'; 
const base_url=process.env.VUE_APP_BASE_URL;


export default {
  name: "AddTeacher",
  components: {},
  data: function() {
    return {
    form: {
        userName: "",
        params:'',
        school: "",
        division:"",
      },
      show: true,
      isCollapsed: true,
      school_list:[],
    };
  },
  methods:{
    onSubmit1(){
      var data = {
            'school_id': this.form.school,
            'division': this.form.division
        };
        console.log(data);
        var promise = apis.add_DivisionMasters(data)
        .then( response => {
          Swal.fire({
              width:200,
              title: 'Division Added Sucessfully !!',
              Text: 'Division Added Sucessfully !!'
          });
          //this.$alert("Division Added Sucessfully");
          //this.$router.go(-1);

        }).catch(error => {
          Swal.fire({
              width:200,
              title: 'Something Went Wrong !!',
              Text: 'Something Went Wrong !!'
          });
        });
    },
      onSubmit() {
        //event.preventDefault();
       
        if(this.para == '' || this.para == undefined){
            // add API will be call
           
          
        }else{
            // edit API will be call
             var data = {
               'school_id': this.id,
                'school_name': this.form.schoolName,
                'address': this.form.schoolAddress,
                'contact_no': this.form.contact,
                'contact_person': this.form.contactPerson,
                'district_id': '00000000-0000-0000-0000-000000000000'
            };
            console.log(data);
            axios.put(base_url + 'api/Schools/'+this.id,data).then( response => {
              this.isLoading = false;
              
              this.$alert("School Updated Sucessfully");
              this.$router.go(-1);

            }).catch(error => {

            });
        }
           
    },
 
   
    get_school(){
       var promise = apis.list_Schools().then( response => {
          this.school_list = response.data;
      }).catch( errror => {

      })
    },
    
  },
  created(){
    this.get_school();
  }
};
</script>
